module.exports = __webpack_public_path__ + "img/laboratorio_9-16_1620.03a26be8.webp";